import * as React from 'react';
import PropTypes from 'prop-types';

function ViewContact(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  const { color = '#fff', width = 24, height = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#clip0_1645_980)"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 12a9 9 0 1018.001 0A9 9 0 003 12z" />
        <path d="M9 10a3 3 0 106 0 3 3 0 00-6 0zM6.168 18.849A4 4 0 0110 16h4a4 4 0 013.834 2.855" />
      </g>
      <defs>
        <clipPath id="clip0_1645_980">
          <path fill="#fff" d="M0 0H24V24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
ViewContact.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ViewContact;
